import {
  ADDRESS_GET, ADDRESS_GET_SUCCESS, ADDRESS_GET_FAILURE
} from './mutation-types'
import axios from 'axios'

export default {
  actions: {
    [ADDRESS_GET] ({dispatch, state, commit}, params) {
      axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + params.postal_code + '&language=ja&sensor=false&key=AIzaSyByDXdyQZfl8V71tOOW8qGhVhEcxywvbz8')
        .then((res) => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(ADDRESS_GET_FAILURE, res.data)
            } else {
              commit(ADDRESS_GET_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },

  mutations: {
    [ADDRESS_GET_FAILURE] (state, data) {
      console.log('ADDRESS_GET_FAILURE')
    },
    [ADDRESS_GET_SUCCESS] (state, data) {
      console.log('ADDRESS_GET_SUCCESS')
      var address = null
      if (data.data.results && data.data.results.length > 0) {
        var addr = address = data.data.results[0]['address_components']
        var address1 = '' // 都道府県 , 郡/市 , 町/区
        for (var i = addr.length - 2; i > 1; i--) {
          address1 += addr[i]['long_name']
        }
        var address2 = addr[1]['long_name']  // 1:字
        address = {address1: address1, address2: address2}
      }
      data.callback(address)
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/address.js